export const getShortNameOfGeoobjectByTitle = (title) => {
    if (!title) return ""
    return title.slice(-6)
}